import atom from '../api/atom';
import BaseFetch from './base';

export default class Atom extends BaseFetch {
    api = atom
}
